import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { SliderWrapper } from './toolBar.styled';

const rangeSliderOffset = 35;

const RangeSlider = observer(props => {
  return (
    <SliderWrapper canvasWidth={props.canvasWidth}>
      <input
        className=' rounded border h-2 mr-1'
        type='range'
        defaultValue={props.value * 50.0 || 0}
        min='0'
        max='100'
        onInput={props.updateOnChange}
        style={{
          width: `calc(100% - ${rangeSliderOffset}px)`,
        }}
      />
    </SliderWrapper>
  );
});

RangeSlider.propTypes = {
  updateOnChange: PropTypes.func,
  toggleExplodeMenu: PropTypes.func,
};

export default RangeSlider;
